var map = {
	"./ad.jpg": 1857,
	"./ad_2.jpg": 3950,
	"./ad_3.jpg": 8279,
	"./ad_4.jpg": 770,
	"./en.jpg": 8679,
	"./login_bg.jpg": 8210,
	"./register_bg.jpg": 6918,
	"./th.jpg": 7694,
	"./vi.jpg": 9769,
	"./zh.jpg": 4268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 911;